import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/comment/list'
    return request.post(url,data)
}

export function all() {
    let url = '/comment/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/comment/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/comment/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/comment/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/comment/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/comment/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/comment/dmz/options'
    return request.get(url)
}
